export default {
  // list
  'crm_customer_parse_excel_config.query.fieldLabel': 'fieldLabel',
  'crm_customer_parse_excel_config.query.fieldLabel.placeholder': 'Enter fieldLabel',
  'crm_customer_parse_excel_config.query.excelCellNo': 'excelCellNo',
  'crm_customer_parse_excel_config.query.excelCellNo.placeholder': 'Enter excelCellNo',
  'crm_customer_parse_excel_config.query.existColumn': 'existColumn',
  'crm_customer_parse_excel_config.query.existColumn.placeholder': 'Enter existColumn',
  'crm_customer_parse_excel_config.column.customerId': 'customerId',
  'crm_customer_parse_excel_config.column.fieldLabel': 'fieldLabel',
  'crm_customer_parse_excel_config.column.fieldProperty': 'fieldProperty',
  'crm_customer_parse_excel_config.column.excelCellNo': 'excelCellNo',
  'crm_customer_parse_excel_config.column.existColumn': 'existColumn',
  'crm_customer_parse_excel_config.column.defaultValue': 'defaultValue',
  'crm_customer_parse_excel_config.column.sortNo': 'sortNo',
  'crm_customer_parse_excel_config.column.createBy': 'createBy',
  'crm_customer_parse_excel_config.column.updateBy': 'updateBy',
  'crm_customer_parse_excel_config.column.createTime': 'createTime',
  'crm_customer_parse_excel_config.column.updateTime': 'updateTime',
  'crm_customer_parse_excel_config.column.dataSource': 'dataSource',
  'crm_customer_parse_excel_config.column.remark': 'remark',
  'crm_customer_parse_excel_config.column.status': 'status',
  // edit
  'crm_customer_parse_excel_config.edit.title': 'Edit CrmCustomerParseExcelConfig',
  'crm_customer_parse_excel_config.add.title': 'Add CrmCustomerParseExcelConfig',
  'crm_customer_parse_excel_config.edit.success': 'Edit Successful',
  'crm_customer_parse_excel_config.add.success': 'Add Successful',
  'crm_customer_parse_excel_config.form.fieldLabel.required': 'fieldLabel cannot be null',
  'crm_customer_parse_excel_config.form.excelCellNo.required': 'excelCellNo cannot be null',
  'crm_customer_parse_excel_config.form.existColumn.required': 'existColumn cannot be null',
  'crm_customer_parse_excel_config.form.fieldProperty.required': 'fieldProperty cannot be null',
  'crm_customer_parse_excel_config.form.fieldLabel': 'fieldLabel',
  'crm_customer_parse_excel_config.form.fieldLabel.placeholder': 'Enter fieldLabel',
  'crm_customer_parse_excel_config.form.excelCellNo': 'excelCellNo',
  'crm_customer_parse_excel_config.form.excelCellNo.placeholder': 'Enter excelCellNo',
  'crm_customer_parse_excel_config.form.existColumn': 'existColumn',
  'crm_customer_parse_excel_config.form.existColumn.placeholder': 'Enter existColumn',
  'crm_customer_parse_excel_config.form.defaultValue': 'defaultValue',
  'crm_customer_parse_excel_config.form.defaultValue.placeholder': 'Enter defaultValue',
  'crm_customer_parse_excel_config.form.remark': 'remark',
  'crm_customer_parse_excel_config.form.remark.placeholder': 'Enter remark',
}
